// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2Fsm5","likeBtn":"_32Mx_","selected":"_53nTg","unlikeBtn":"_3oV4l"};